import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'compact-upload-modal',
  templateUrl: './compactUploadModal.component.html',
  styleUrls: ['./compactUploadModal.component.scss'],
})
export class CompactUploadModalComponent {
  @Input() isLeavingPage;
  @Output() onConfirmCancelUploading = new EventEmitter();
  @Output() onContinueUploading = new EventEmitter();

  constructor() {}

  confirmCancelUploading() {
    this.onConfirmCancelUploading.emit();
  }

  continueUploading() {
    this.onContinueUploading.emit();
  }
}
